import { Instagram, Mail, MessageSquare } from "lucide-react";

const QUICK_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id.replace("#", ""));
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer-section"
      className="relative border-t border-white/10 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="font-display text-3xl tracking-tight leading-none text-white">
                <span className="italic">A</span>
                <span className="italic -ml-1.5">S</span>
              </span>
              <span className="text-[10px] tracking-[0.32em] uppercase text-white/60 border-l border-white/15 pl-3">
                Almonte Sites
              </span>
            </div>
            <p className="mt-5 text-white/55 text-sm max-w-sm leading-relaxed">
              Website design for local businesses. Built by Elijah Almonte —
              clean sites that turn visitors into customers.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-medium">
              Quick Links
            </div>
            <ul className="mt-5 space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    onClick={() => scrollTo(l.href)}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-medium">
              Connect
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a
                  data-testid="footer-instagram"
                  href="https://instagram.com/almontesites"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Instagram size={15} />
                  @almontesites
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href="mailto:almontesites@gmail.com"
                  className="inline-flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <Mail size={15} />
                  almontesites@gmail.com
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone"
                  href="sms:+17863287686"
                  className="inline-flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                >
                  <MessageSquare size={15} />
                  786-328-7686
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} Almonte Sites · Elijah Almonte. All rights reserved.
          </div>
          <div className="text-xs text-white/40 italic">
            Designed to convert. Built to last.
          </div>
        </div>
      </div>
    </footer>
  );
}
